import { z } from 'zod';

import { AGENT_TEXT_MAX_LENGTH, AGENT_TITLE_MAX_LENGTH } from './_enums';

const sendAgentMessageSchema = z.object({
  text: z.string().trim().min(1, 'Type a message to send.').max(AGENT_TEXT_MAX_LENGTH, `Keep it under ${AGENT_TEXT_MAX_LENGTH} characters.`)
});

const editAgentConversationSchema = z.object({
  title: z.string().trim().min(1, 'Give the conversation a name.').max(AGENT_TITLE_MAX_LENGTH, `Keep it under ${AGENT_TITLE_MAX_LENGTH} characters.`)
});

const deleteAgentConversationSchema = z.object({
  is_confirmed: z.boolean().refine((val) => val === true, {
    message: 'You must confirm this action by checking the box.'
  })
});

export { sendAgentMessageSchema, editAgentConversationSchema, deleteAgentConversationSchema };
